import * as d3 from 'd3';
import { CirclePacking } from '../../../models/circlePackingModel';

export const scaleToValue: (siblings: Array<CirclePacking>, rangeFontSize: Array<number>, value: number) => number = (
  siblings,
  rangeFontSize,
  value
) => {
  const dataRange = d3.extent(siblings, (d) => d.doc_count);
  const scaleFont = d3.scaleLinear().domain(dataRange).range(rangeFontSize);
  return scaleFont(value);
};

export const scaleValueToRadius: (siblings: Array<CirclePacking>, rangeRadius: Array<number>, value: number) => number = (
  siblings,
  rangeRadius,
  value
) => {
  const scaleSize = d3
    .scaleLinear()
    .domain(d3.extent(siblings, (d) => d.doc_count))
    .range(rangeRadius);

  return scaleSize(value);
};
